
















import Vue, { PropType } from 'vue';
import { VFairWebinar } from '~/services/VFairService';
import VideoItem from './VideoItem.vue';

export default Vue.extend({
    name: 'VideoList',
    components: {
        VideoItem,
    },
    props: {
        value: {
            type: Array as PropType<VFairWebinar[]>,
            required: true,
        },
        width: {
            type: String,
            default: '',
        },
    },
});
